import { ReportSectionComponentType } from '../types';
import { useState } from 'react';
import { useUpdateReport } from '../../common/components/mutations';
import FNAs from '../../fna/FNAs';
import StepFooter from '../../common/components/stepFooter';

/**
 * Select FNAs for the report
 */
const SelectFnaStep: ReportSectionComponentType = ({
  onClickBack,
  onClickNext,
  report,
  isLoading: isSomethingLoading,
}) => {
  const [selectedIds, setSelectedIds] = useState<number[]>(report.fnAs.map(({ id }) => id));
  const { mutate, isPending } = useUpdateReport();

  const handleClickNext = (): void => {
    mutate(
      {
        ...report,
        fnAs: selectedIds?.map((id) => ({ id })) ?? [],
      },
      {
        onSuccess: onClickNext,
      },
    );
  };

  return (
    <>
      <FNAs
        editable={false}
        roleplayerId={report.roleplayers[0]?.roleplayerID}
        selectedIds={selectedIds}
        onClickSelect={(fna): void => setSelectedIds([fna.id])}
        localeText={{
          noRowsLabel:
            'There aren’t any FNA’s created for this client. Click ‘Next’ to continue building a report without FNA’s',
        }}
      />
      <StepFooter
        isLoading={isPending || isSomethingLoading}
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
      />
    </>
  );
};

export default SelectFnaStep;
